import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';


import * as textareaConstants from './textareaConstants';

import styles from './Textarea.scss';


function Textarea({isDisabled, id, maxLength, name, onChange, placeholder, value}) {

    /**
     * @type {string} currentValue
     */
    const [currentValue, setCurrentValue] = useState(value);

    useEffect(() => {

        // if either field is set and the values differ, update with the external value
        if ((currentValue || value) && value !== currentValue) {
            setCurrentValue(value || '');
        }
    }, [value]);

    return (
        <textarea
            className={styles.textarea}
            disabled={isDisabled}
            id={id}
            maxLength={maxLength}
            name={name}
            draggable={false}
            onChange={event => {

                // prevent re-rendering the dom node
                const newValue = event.target.value || null;
                setCurrentValue(newValue);

                onChange(newValue);
            }}
            placeholder={placeholder}
            value={currentValue || ''}
        />
    );
}


Textarea.propTypes = {
    id: PropTypes.string,
    isDisabled: PropTypes.bool,
    maxLength: PropTypes.number,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    placeholder: PropTypes.string,
    value: PropTypes.string
};

Textarea.defaultProps = {
    isDisabled: false,
    maxLength: textareaConstants.MAX_LENGTH,
    name: 'textarea'
};


export default Textarea;
